import dayjs from "dayjs";

const useDateFunc = () =>
{
  const compare = (x, y) =>
  {
    if (x.setHours(0, 0, 0, 0).valueOf() > y.setHours(0, 0, 0, 0).valueOf())
      return true;
    return false;
  };
  const isSame = (x, y) =>
  {
    if (x.setHours(0, 0, 0, 0).valueOf() === y.setHours(0, 0, 0, 0).valueOf())
      return true;
    return false;
  }
  const compareWithHours = (x, y) =>
  {
    if (x.valueOf() > y.valueOf())
      return true;
    return false;
  };
  const dateFromToday = (range) =>
  {
    let newDate = new Date();
    newDate.setDate(newDate.getDate() + range);
    return newDate;
  };

  const getTimeZoneOffset = () =>
  {
    var date = new Date();
    return Math.floor((date.getTimezoneOffset() / 60) * -1);
  };

  const getDatesInRange = (s, e) =>
  {
    const d = new Date(s.detTime());
    const dates = [];
    while (
      d.setHours(0, 0, 0, 0).valueOf() <= e.setHours(0, 0, 0, 0).valueOf()
    )
    {
      dates.push(d.setHours(0, 0, 0, 0).valueOf());
      d.setDate(d.getDate() + 1);
    }
    return dates;
  };

  const getDiffs = (start, end) =>
  {
    var diffMs = end.getTime() - start.getTime();
    var diffDays = Math.floor(diffMs / 86400000); // days
    var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
    var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
    return { days: diffDays, hours: diffHrs, mins: diffMins };
  };

  const formatDate = (dateString, format = "DD-MM-YYYY") =>
  {
    return dayjs(dateString).format(format);
  };

  const formatOnlyHours = (dateString) =>
  {
    let d = new Date(dateString);
    const hour = d.getHours() < 10 ? `0${d.getHours()}` : d.getHours();
    const min = d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes();
    return `${hour}:${min}`;
  };

  const formatOnlyHoursUTC = (dateString) =>
  {
    let d = new Date(dateString);
    const hour = d.getUTCHours() < 10 ? `0${d.getUTCHours()}` : d.getUTCHours();
    const min =
      d.getUTCMinutes() < 10 ? `0${d.getUTCMinutes()}` : d.getUTCMinutes();
    return `${hour}:${min}`;
  };

  const sortDates = (dates) =>
  {
    let sortedDates = dates.sort((current, previous) =>
    {
      return Date.parse(current) > Date.parse(previous);
    });
    return sortedDates;
  };

  const sortTimes = (times) =>
  {
    return times.sort((a, b) =>
    {
      return (
        Date.parse("1970/01/01 " + a.hour) - Date.parse("1970/01/01 " + b.hour)
      );
    });
  };
  const getOldestDate = (dates) =>
  {
    let oldest = dates.reduce((current, previous) =>
    {
      return Date.parse(current) > Date.parse(previous) ? previous : current;
    });
    return oldest;
  };

  const getLatestDate = (dates) =>
  {
    let latest = dates.reduce((current, previous) =>
    {
      return Date.parse(current) > Date.parse(previous) ? current : previous;
    });
    return latest;
  };

  const getLocaleTime = (time, mul = -1) =>
  {
    //time format should be "hh:mm"
    const currentDate = new Date();
    const splittedTime = time.split(":");
    const timezoneOffset = (currentDate.getTimezoneOffset() / 60) * mul;
    var localeHour = parseInt(splittedTime[0]);
    var i = 0;
    if (localeHour >= 24)
    {
      localeHour = localeHour % 24;
      i = 1;
    } else if (localeHour < 0)
    {
      localeHour = 24 + localeHour;
      i = -1;
    }
    const hour =
      localeHour < 10 && localeHour.length != 2
        ? `0${localeHour}`
        : `${localeHour}`;
    const min =
      parseInt(splittedTime[1]) < 10 && splittedTime[1].length < 2
        ? `0${splittedTime[1]}`
        : `${splittedTime[1]}`;
    //hour & index
    return [`${hour}:${min}`, i];
  };
  function sToTime(t)
  {
    return padZero(parseInt((t / (60 * 60)) % 24)) + ":" +
      padZero(parseInt((t / (60)) % 60)) + ":" +
      padZero(parseInt((t) % 60));
  }
  function padZero(v)
  {
    return (v < 10) ? "0" + v : v;
  }
  return {
    compare,
    compareWithHours,
    isSame,
    dateFromToday,
    getTimeZoneOffset,
    getLocaleTime,
    getDatesInRange,
    getDiffs,
    formatDate,
    formatOnlyHours,
    formatOnlyHoursUTC,
    sortDates,
    sortTimes,
    getOldestDate,
    getLatestDate,
    sToTime
  };
};
export default useDateFunc;
